import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';

import PublicLayout from './components/layout/PublicLayout';
import Home from './pages/Home';
import AppDetail from './pages/AppDetail';
import AppLive from './pages/AppLive';
import NotFound from './pages/NotFound';
import Spinner from './components/ui/Spinner';

import { ThemeProvider } from './contexts/ThemeContext';

// Khu quản trị tách hẳn thành chunk riêng: nó kéo theo Firebase Auth và trình
// nén ảnh, những thứ người xem trang chủ không bao giờ chạm tới.
const AdminApp = lazy(() => import('./pages/admin/AdminApp'));

const FullPageSpinner = () => (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <Spinner size="md" />
    </div>
);

/** Giữ tương thích với các link cũ dạng buitientuan.com/<slug>. */
const LegacyRedirect = () => {
    const { legacyId } = useParams();
    return <Navigate to={`/app/${legacyId}`} replace />;
};

const App = () => (
    <ThemeProvider>
        <BrowserRouter>
            <Routes>
                <Route
                    path="/admin/*"
                    element={
                        <Suspense fallback={<FullPageSpinner />}>
                            <AdminApp />
                        </Suspense>
                    }
                />

                <Route
                    path="/"
                    element={
                        <PublicLayout>
                            <Home />
                        </PublicLayout>
                    }
                />
                <Route
                    path="/app/:id"
                    element={
                        <PublicLayout>
                            <AppDetail />
                        </PublicLayout>
                    }
                />
                <Route
                    path="/app/:id/mo"
                    element={
                        <PublicLayout showFooter={false}>
                            <AppLive />
                        </PublicLayout>
                    }
                />

                <Route path="/:legacyId" element={<LegacyRedirect />} />

                <Route
                    path="*"
                    element={
                        <PublicLayout>
                            <NotFound />
                        </PublicLayout>
                    }
                />
            </Routes>
        </BrowserRouter>
    </ThemeProvider>
);

export default App;
